import { create } from 'zustand';

type SelectedProjectsStore = {
  projects: string[];
};

const initialState: SelectedProjectsStore = {
  projects: [],
};

export const useSelectedProjectsStore = create<SelectedProjectsStore>(() => initialState);

export const setSelectedProjects = (id: string) => {
  const oldProjects = useSelectedProjectsStore.getState().projects;

  if (oldProjects.includes(id)) {
    return useSelectedProjectsStore.setState({ projects: oldProjects.filter((project) => project !== id) });
  }

  return useSelectedProjectsStore.setState({ projects: [...oldProjects, id] });
};

export const resetSelectedProjects = () => useSelectedProjectsStore.setState({ ...initialState });
